<template>
	<b-form-select
		v-model="country"
		:options="countryOptions"
		:disabled="disabled"
		@input="emitChangeEvent"
	/>
</template>

<script>
import _ from "lodash";

export default {

	props: {
		value: {
			type: Number,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		emptyOption: {
			type: String,
			required: false,
		},
	},

	data ()
	{
		let countryOptions = _.map(this.meta.country, item =>
		{
			return {
				value: item.id,
				text: item.text,
			}
		});

		if (this.emptyOption)
		{
			countryOptions.unshift({
				value: null,
				text: this.emptyOption,
			});
		}

		return {
			country: this.value || null,
			countryOptions: Object.freeze(countryOptions),
		};
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', this.country);
		},
	},

	watch: {
		value (v)
		{
			this.country = v;
		}
	}
}
</script>